export const COLORS = {
  GRAY: '#909090'
};
